// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as pbFunc from "./assets/utils";
import {
  httpServer
} from "./api/index";
import BaiduMap from "vue-baidu-map";
import echarts from "echarts";

import store from './store/index.js'

Vue.config.productionTip = false;

Vue.prototype.pbFunc = pbFunc;
Vue.prototype.$$http = httpServer;
Vue.prototype.$Echarts = echarts;
Vue.prototype.$CloseNotify = null;
Vue.prototype.$alarmNum = 0;

Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: "Xv0K5rlu331GMuveMXy8sGnF"
});


/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
  created() {
    let token = pbFunc.getLocalData('token', true);
    if (!token) {
      router.push({
        path: '/',
      });
    }

    router.beforeEach((to, from, next) => {
      let token = pbFunc.getLocalData('token', true);
      // next();
      // console.log('list', token)
      if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
        if (token) { // 判断当前的token是否存在
          next();
        } else {
          this.$message.error('登录过期，请重新登录');
          next({
            path: '/',
          })
        }
      } else {
        next();
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js